import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { useTranslation } from 'react-i18next';
import { EBulkActionFeatures } from '../table_base/EBulkActionFeatures';
import { EFeaturesCategory } from '../table_base/EFeaturesCategory';
import { WSFeaturesTableHeader } from '../table_base/WSFeaturesTableHeader';
import { WSFeaturesTableRow } from './WSFeaturesTableRow';

interface Props {
  category: string;
}

export const WSFeaturesTable: React.FC<Props> = ({ category }) => {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  /*
   * RENDERS
   */
  function render_rows() {
    const featuresArray =
      category == EFeaturesCategory.BULK_ACTIONS
        ? [EBulkActionFeatures.ALLOW, EBulkActionFeatures.DENY]
        : Object.values(ENUM__workspace_entity_feature).filter(item => item.includes(category));

    return featuresArray.map((item, index) => <WSFeaturesTableRow key={`${item}_${index}`} feature={item} index={index} category={category} />);
  }

  /*
   * HTML
   */

  if (!i18n_page_settings_workspace.tabs.features_access.table[category]) {
    console.log(i18n_page_settings_workspace.tabs.features_access.table);
    debugger;
  }

  return (
    <div className="w-full h-full">
      <div
        className={`${md(
          'h-full w-full overflow-auto',
          ' pt-2',
        )} mt-3  flex flex-col justify-center items-start  border-b border-component-border  text-page-foreground`}
      >
        <div className={`${md(' px-2 justify-start gap-2', 'px-5 justify-start')}   w-full min-h-[50px] flex flex-row items-center    mt-2`}>
          <span className={`${md('min-w-[130px] text-[10px]', 'w-[400px]')}  text-left`}>
            {t(i18n_page_settings_workspace.tabs.features_access.table[category].title)}
          </span>
          <WSFeaturesTableHeader />
        </div>
        <div className="w-full border-t border-component-item"></div>
        <div className="flex flex-col justify-start items-center h-full w-full ">{render_rows()}</div>
      </div>
    </div>
  );
};
